import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logoutClick } from "../redux/Actions/UserActions";
import { formatNumber, ListMyOrdersNone } from "../service";
import BannerSlider from "./BannerSlider";
import { useLocation } from "react-router-dom";
import { Search } from "./Search";
import { BiCart } from "react-icons/bi";
import { CardButton } from "./CardButton";
import { CallButton } from "./CallButton";
import { HiMiniBars3 } from "react-icons/hi2";
import { Sidebar } from "./Sidebar";
import { Logo } from "./Logo";

const Header = () => {
  const dispatch = useDispatch();
  const [dataU, setDataU] = useState({});
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const location = useLocation();

  const [uuid, setUuid] = useState(localStorage.getItem('uuid'));
  const [orders, setOrderS] = useState(localStorage.getItem('uuid'));
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [open, setOpen] = useState(false);

  const logoutHandler = () => {
    dispatch(logoutClick());
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getInfoUserActive();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getList()
  }, [uuid]);

  const getList = async () => {
    let sssss = await ListMyOrdersNone();
    if (sssss) {
      setOrderS(sssss)
    }
    console.log(sssss);
  }


  const getInfoUserActive = async () => {
    // console.log(window.localStorage.getItem('userInfoActive'));
    if (!window.localStorage.getItem('userInfoActive')) {
      return
    }
    let data = JSON.parse(window.localStorage.getItem('userInfoActive'));
    // console.log(data);
    setDataU(data)
  };

  return (
    <div className="w-full flex justify-center items-center h-[100px] ">
      <Sidebar open={open} setOpen={setOpen}/>
      <div className="w-[--page-width] ">
        <div className="w-full grid grid-cols-12">
          <div className="order-1 col-span-6 lg:col-span-1  xl:col-span-1  flex  justify-start items-center p-2">
            <button className=" block lg:hidden xl:hidden" onClick={()=>setOpen(true)}><HiMiniBars3 className="text-xl" /></button>
           <Logo/>
          </div>
          <div className="order-3 xl:order-2 lg:order-2 bg-[--color-button-3] lg:bg-transparent xl:bg-transparent p-2   col-span-12  lg:col-span-6  xl:col-span-7 flex justify-center items-center ">

            <Search className={"!h-[35px] !w-[70%] lg:!h-[40px]  lg:!w-[80%] xl:!h-[40px]  xl:!w-[80%]"} />
          </div>
          <div className="order-2 xl:order-3 lg:order-3 col-span-6  lg:col-span-5   xl:col-span-4 flex  justify-end items-center gap-2 p-2">
            <CallButton />
            <div className="w-1 border-l border-l-gray-300 h-[20px] lg:h-[40px]  xl:h-[40px] mx-2 lg:mx-1 xl:mx-1"></div>
            <CardButton />
            
        
          </div>
          {/* <div className="">
            <div className="" >
              <div className="">
                <Link to="/cart">
                  <i className="fas fa-shopping-bag"></i>
                  <span className="badge">{cartItems.length}</span>
                </Link>
              </div>
            </div>
            <div className="">
              <div className="">
                {userInfo ? (
                  <div className="">
                    <button
                      type="button"

                    >
                      <i className="fas fa-user"></i>

                    </button>
                    <div className="">
                      <Link className="" to="/profile">
                        Hồ sơ
                      </Link>
                     
                      <Link
                        className=""
                        to="#"
                        onClick={logoutHandler}
                      >
                        Đăng xuất
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="">
                    <button
                      type="button"

                    >
                      <i className="fas fa-user"></i>
                    </button>
                    <div className="">
                      <Link to="/login">
                        Đăng nhập
                      </Link>
                      <Link to="/register">
                        Đăng kí
                      </Link>
                    </div>
                  </div>
                )}
                <Link to="/cart" >
                  <i className="fas fa-shopping-bag"></i>
                  <span className="badge">{cartItems.length}</span>
                </Link>
              </div>
            </div>
            {
              orders?.length > 0 && !userInfo ?

                <div className="">
                  <Link to="/orders-none">
                    <i className="fas fa-clipboard-list"></i>
                    <span className="badge">{orders?.length}</span>
                  </Link>
                </div>
                :
                <div style={{ color: '#fff' }}>Số dư: {formatNumber(dataU?.balance)}</div>
            }

          </div> */}
        </div>
      </div>

    </div>
  );
};

export default Header;
